import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CustomInput from "../../components/CustomInput";
import { ResetPasswordValidate } from "../../helper/Validation";
import { useForm } from "../../hooks/useForm";
import { LoadingButton } from "@mui/lab";
import Carousel from "react-material-ui-carousel";
import styles from "./styles";

const ResetPasswordPageWrapper = ({ handleResetPassword, loading, onBack }) => {
  const resetPasswordInitialData = {
    newPassword: {
      value: "",
      error: "",
    },
    confirmPassword: {
      value: "",
      error: "",
    },
  };

  const handleSubmit = async (data) => {
    if (data.newPassword.value !== data.confirmPassword.value) {
      return;
    }
    handleResetPassword(data);
  };

  const { state, handleChange, handleSubmit: formSubmit, handleFocus, disable } = useForm(
    resetPasswordInitialData,
    ResetPasswordValidate,
    handleSubmit,
  );

  const { newPassword, confirmPassword } = state;

  const passwordsMatch = newPassword.value && confirmPassword.value && newPassword.value === confirmPassword.value;
  const passwordMismatchError = newPassword.value && confirmPassword.value && newPassword.value !== confirmPassword.value;

  return (
    <Box sx={styles.main}>
      <Container sx={styles.root}>
        <Paper sx={styles.paper}>
          <Grid container sx={styles.gridContainer}>
            <Grid item xs={12} sm={12} md={6} sx={styles.gridItem}>
              <Box sx={styles.formContain}>
                {/* Back Button */}
                <Button
                  onClick={onBack}
                  sx={{
                    textTransform: "none",
                    color: "#1976d2",
                    marginBottom: 2,
                    padding: 0,
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  &larr; Back to OTP
                </Button>

                <Typography variant="h4" sx={styles.mainheading}>
                  Reset Password
                </Typography>
                <Box sx={styles.headingborder}></Box>

                <Typography sx={styles.descriptionText}>
                  Enter your new password. Make sure it&apos;s strong and secure.
                </Typography>

                <form onSubmit={formSubmit} autoComplete="off">
                  {/* New Password Field */}
                  <Box sx={{ mb: 2 }}>
                    <Typography sx={styles.inputText}>New Password</Typography>
                    <CustomInput
                      name="newPassword"
                      type="password"
                      value={newPassword?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={newPassword?.error && !passwordsMatch ? newPassword?.error : ""}
                    />
                  </Box>

                  {/* Confirm Password Field */}
                  <Box sx={{ mb: 3 }}>
                    <Typography sx={styles.inputText}>Confirm Password</Typography>
                    <CustomInput
                      name="confirmPassword"
                      type="password"
                      value={confirmPassword?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={passwordMismatchError ? "Passwords do not match" : (confirmPassword?.error && !passwordsMatch ? confirmPassword?.error : "")}
                    />
                    {passwordsMatch && (
                      <Typography sx={styles.successMessage}>
                        ✓ Passwords match
                      </Typography>
                    )}
                  </Box>

                  <LoadingButton
                    loading={loading}
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={disable || !passwordsMatch}
                    sx={styles.submit}
                  >
                    Reset Password
                  </LoadingButton>
                </form>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Carousel indicators={false}>
                <Box sx={styles.image}>
                  <Box sx={styles.backgroundImage}></Box>
                  <Typography sx={styles.sliderText}>
                    Protect your account with a strong password. Use a combination of uppercase, lowercase, numbers, and special characters.
                  </Typography>
                  <Box sx={styles.dots}>
                    <Box sx={styles.dot2}></Box>
                    <Box sx={styles.dot1}></Box>
                  </Box>
                </Box>
                <Box sx={styles.image}>
                  <Box sx={styles.backgroundImage2}></Box>
                  <Typography sx={styles.sliderText}>
                    Your password reset is encrypted and secure. Complete the process in the next few steps.
                  </Typography>
                  <Box sx={styles.dots}>
                    <Box sx={styles.dot1}></Box>
                    <Box sx={styles.dot2}></Box>
                  </Box>
                </Box>
              </Carousel>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default ResetPasswordPageWrapper;
